"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _uxcore = require("@ux/uxcore2");
var _search = _interopRequireDefault(require("@ux/search"));
require("@ux/search/styles");
var _storeProvider = require("./../util/storeProvider");
var _DomainResultsComponent = _interopRequireDefault(require("./DomainResultsComponent"));
var _traffic = _interopRequireDefault(require("./../util/traffic"));
var _chevronRight = _interopRequireDefault(require("@ux/icon/chevron-right"));
var _search2 = _interopRequireDefault(require("@ux/icon/search"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const domainSearch = "dc8j7k7";
class DomainSearchComponent extends _react.Component {
  constructor(props) {
    super(props);
    this.inputRef = /*#__PURE__*/_react.default.createRef();
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleContinue = this.handleContinue.bind(this);
  }
  componentDidMount() {
    _traffic.default.addPageRequest('domainsearch');
    if (this.inputRef.current?.formElement?.elements?.input) {
      this.inputRef.current.formElement.elements.input.focus();
    }
  }
  handleContinue() {
    this.context.store.handleContinueClick();
  }
  handleSearch() {
    const value = this.inputRef.current.value;
    _traffic.default.addEvent({
      eid: this.context.store.getEid('domainsearch', 'submit', 'click')
    });
    this.context.store.domainSearchApi.search({
      query: value,
      apiKey: this.props.groupContent.apiKey,
      tmsKey: this.props.groupContent['tms-key']
    });
  }
  handleChange(value) {
    const splitValue = value.split('.');
    const sldMaxCharacters = 64;
    if (splitValue[0].length >= sldMaxCharacters) {
      splitValue[0] = splitValue[0].substr(0, sldMaxCharacters - 1);
      this.inputRef.current.setStateAndClose({
        value: splitValue.join('.')
      });
    }
  }
  render() {
    const {
      context: {
        store
      },
      props
    } = this;
    const {
      groupContent = {},
      commonContent = {},
      disabled
    } = props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "mt-3"
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: `domain-search ${domainSearch}`
    }, /*#__PURE__*/_react.default.createElement(_search.default, {
      id: "domainSearch",
      disabled: disabled,
      className: "flew-row",
      onChange: this.handleChange,
      ref: this.inputRef,
      "data-eid": store.getEid('domain_name', 'button', 'submit'),
      placeholder: groupContent['domain-search-placeholder'],
      design: "primary",
      clearable: false,
      button: /*#__PURE__*/_react.default.createElement(_uxcore.Button, {
        text: groupContent['domain-search-button'],
        design: "primary",
        onClick: this.handleSearch,
        icon: /*#__PURE__*/_react.default.createElement(_search2.default, null)
      })
    })), /*#__PURE__*/_react.default.createElement("div", {
      className: "row text-right",
      ref: this.continueButtonDiv
    }, /*#__PURE__*/_react.default.createElement(_uxcore.Button, {
      className: "no-thanks-button",
      "data-eid": this.context.store.getEid('continue', 'submit', 'click'),
      design: "inline",
      onClick: this.handleContinue,
      disabled: disabled,
      icon: /*#__PURE__*/_react.default.createElement(_chevronRight.default, {
        width: 16,
        height: 16
      }),
      text: commonContent.noThanksOnFreeOffer
    })), /*#__PURE__*/_react.default.createElement(_DomainResultsComponent.default, {
      disabled: disabled,
      content: groupContent,
      includeState: [{
        path: 'domainSearch',
        propKey: 'domainSearch'
      }]
    }));
  }
}
DomainSearchComponent.propTypes = {
  commonContent: _propTypes.default.object,
  groupContent: _propTypes.default.object,
  disabled: _propTypes.default.bool
};
var _default = exports.default = (0, _storeProvider.provideContext)(DomainSearchComponent);